const currencyFormatter = new Intl.NumberFormat('sk-SK', {
  style: 'currency',
  currency: 'EUR',
});

/** Format a whole-euro amount (the unit used across orders/products/expenses). */
export const formatCurrency = (value: number) => currencyFormatter.format(value || 0);

/** Format a percentage given as a plain number, e.g. 90 -> "90 %". */
export const formatPercent = (value: number) =>
  new Intl.NumberFormat('sk-SK', { style: 'percent', maximumFractionDigits: 1 }).format(
    (value || 0) / 100
  );
